<template>
    <div class="container-01">
        <h2>CONTACT</h2>
        <ul class="container-02">
            <li>
                <img src="@/assets/icons/phone.svg"/>
                <a class="body clean" v-bind:href=tel>{{ contact.phone }}</a>
            </li>
            <li>
                <img src="@/assets/icons/email.svg"/>
                <a class="body clean" v-bind:href=mailto>{{ contact.email }}</a>
            </li>
            <li>
                <img src="@/assets/icons/link.svg"/>
                <a class="body clean" v-bind:href=contact.www>{{ contact.www }}</a>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import { ResumeContact } from '@/models/Resume'
import { defineComponent, PropType } from 'vue'

export default defineComponent({
    name: "contact",
    props: {
        contact: {
            type: Object as PropType<ResumeContact>,
            required: true
        } 
    },
    computed: {
        tel(): string {
            return `tel:${this.contact.phone.split(" ").join("") }`
        },
        mailto(): string {
            return `mailto:${this.contact.email}`
        }
    }
})
</script>

<style lang="stylus" scoped>

@import "~../../src/styles/styles";

img
    height 16pt
    width @height

li 
    text-indent: 0
    list-style-type: none
    display: flex
    gap spacing-small
    align-items: center

.clean
    text-decoration: none
</style>